var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3875 0.562988H2.72078C1.57495 0.562988 0.637451 1.50049 0.637451 2.64632V19.313C0.637451 20.4588 1.57495 21.3963 2.72078 21.3963H19.3875C20.5333 21.3963 21.4708 20.4588 21.4708 19.313V2.64632C21.4708 1.50049 20.5333 0.562988 19.3875 0.562988ZM6.88745 19.313H2.72078V15.1463H6.88745V19.313ZM6.88745 13.063H2.72078V8.89632H6.88745V13.063ZM6.88745 6.81299H2.72078V2.64632H6.88745V6.81299ZM13.1375 19.313H8.97079V15.1463H13.1375V19.313ZM13.1375 13.063H8.97079V8.89632H13.1375V13.063ZM13.1375 6.81299H8.97079V2.64632H13.1375V6.81299ZM19.3875 19.313H15.2208V15.1463H19.3875V19.313ZM19.3875 13.063H15.2208V8.89632H19.3875V13.063ZM19.3875 6.81299H15.2208V2.64632H19.3875V6.81299Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridInactive);
export default __webpack_public_path__ + "static/media/grid-inactive.2ea909baec6f586a51b099f5e8cf7d21.svg";
export { ForwardRef as ReactComponent };